export const calculateDirittoPrevendita = (ddp?: string | null) => {
  return ddp ? Number(ddp) : null;
};
